export const ALLOWED_MIME_TYPES = [
    'image/png',
    'image/jpeg',
    'image/gif',
    'application/pdf',
    'application/rtf',
    'application/vnd.oasis.opendocument.text',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword'
];

export const MAX_FILE_EXCEEDED_ERROR_CODE = '1080';

export const FILE_NAME_INVALID_ERROR_CODE = '1061';



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/filesConstraints.constants.ts